import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  searchEvent = new EventEmitter<string | null>();
  updateEvent = new EventEmitter<string | null> ;
}
